import moment from "moment";
import { DateRanges } from "@/enums/DateRanges";

export const computedStartDate = (selectedRange: number) => {
  let startDate = "";
  const vatFirstQuarterStartDate = moment(
    `04/01/${moment().year()}`,
    "DD/MM/YYYY",
  );
  const vatSecondQuarterStartDate = moment(
    `07/01/${moment().year()}`,
    "DD/MM/YYYY",
  );
  const vatThirdQuarterStartDate = moment(
    `10/01/${moment().year()}`,
    "DD/MM/YYYY",
  );
  const vatLastQuarterStartDate = moment(
    `01/01/${moment().year()}`,
    "DD/MM/YYYY",
  );

  switch (selectedRange) {
    case DateRanges.Today:
      startDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisWeek:
      startDate = moment().startOf("week").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisMonth:
      startDate = moment().startOf("month").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisYear:
      startDate = moment().startOf("year").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Yesterday:
      startDate = moment().subtract(1, "days").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastWeek:
      startDate = moment()
        .subtract(1, "weeks")
        .startOf("week")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastMonth:
      startDate = moment()
        .subtract(1, "months")
        .startOf("month")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastYear:
      startDate = moment()
        .subtract(1, "years")
        .startOf("year")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastMonthLastYear:
      startDate = moment()
        .subtract(13, "months")
        .startOf("month")
        .format("YYYY/MM/DD HH:mm:ss");
      break;
    case DateRanges.TwoMonths:
      startDate = moment()
        .subtract(2, "months")
        .startOf("month")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Last30Days:
      startDate = moment().subtract(30, "days").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Last60Days:
      startDate = moment().subtract(60, "days").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Last90Days:
      startDate = moment().subtract(90, "days").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisFinancialYear:
      startDate = moment().startOf("year").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisHMRCTaxYear:
      startDate = moment(`04/06/${moment().year()}`).format(
        "yyyy/MM/DD hh:mm:ss",
      );
      break;
    case DateRanges.ThisVATYear:
      startDate = moment(`04/01/${moment().year()}`).format(
        "yyyy/MM/DD hh:mm:ss",
      );
      break;
    case DateRanges.ThisVATQuarter:
      if (
        moment().isSameOrAfter(vatFirstQuarterStartDate) &&
        moment().isSameOrBefore(vatSecondQuarterStartDate)
      ) {
        startDate = vatFirstQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatSecondQuarterStartDate) &&
        moment().isSameOrBefore(vatThirdQuarterStartDate)
      ) {
        startDate = vatSecondQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      }

      // if the date falls on or after the 1st Oct of this year or falls on or before the 1st Jan this year, we're in the the third quarter
      else if (
        moment().isSameOrAfter(vatThirdQuarterStartDate) ||
        moment().isSameOrBefore(moment(vatLastQuarterStartDate))
      ) {
        startDate = vatThirdQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatLastQuarterStartDate) &&
        moment().isSameOrBefore(moment(vatFirstQuarterStartDate))
      ) {
        startDate = vatLastQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      }
      break;
    case DateRanges.LastVATQuarter:
      if (
        moment().isSameOrAfter(vatFirstQuarterStartDate) &&
        moment().isSameOrBefore(vatSecondQuarterStartDate)
      ) {
        startDate = vatLastQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatSecondQuarterStartDate) &&
        moment().isSameOrBefore(vatThirdQuarterStartDate)
      ) {
        startDate = vatFirstQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        (moment().isSameOrAfter(vatThirdQuarterStartDate) &&
          moment().isSameOrBefore(
            moment(vatLastQuarterStartDate).add(1, "years"),
          )) ||
        moment().isSameOrBefore(moment(vatLastQuarterStartDate))
      ) {
        startDate = vatSecondQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatLastQuarterStartDate) &&
        moment().isSameOrBefore(moment(vatFirstQuarterStartDate))
      ) {
        startDate = vatThirdQuarterStartDate.format("yyyy/MM/DD hh:mm:ss");
      }
      break;
    case DateRanges.LastFinancialYear:
      startDate = moment()
        .subtract(1, "years")
        .startOf("year")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastHMRCTaxYear:
      startDate = moment(`04/06/${moment().year()}`)
        .subtract(1, "years")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastVATYear:
      startDate = moment(`04/01/${moment().year()}`)
        .subtract(1, "years")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.AllDates:
      startDate = moment(`01/01/1900`).format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.CustomRange:
      startDate = moment().subtract(1, "months").format("YYYY/MM/DD HH:mm:ss");
      break;
    default:
      startDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
  }

  return startDate;
};

export const computedEndDate = (selectedRange: number) => {
  let endDate = "";
  const vatFirstQuarterEndDate = moment(
    `06/30/${moment().year()}`,
    "DD/MM/YYYY",
  );
  const vatSecondQuarterEndDate = moment(
    `09/30/${moment().year()}`,
    "DD/MM/YYYY",
  );
  const vatThirdQuarterEndDate = moment(
    `12/31/${moment().year()}`,
    "DD/MM/YYYY",
  );
  const vatLastQuarterEndDate = moment(
    `03/31/${moment().year()}`,
    "DD/MM/YYYY",
  );

  switch (selectedRange) {
    case DateRanges.Today:
      endDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisWeek:
      endDate = moment().endOf("week").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisMonth:
      endDate = moment().endOf("month").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisYear:
      endDate = moment().endOf("year").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Yesterday:
      endDate = moment().subtract(1, "days").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastWeek:
      endDate = moment()
        .subtract(1, "weeks")
        .endOf("week")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastMonth:
      endDate = moment()
        .subtract(1, "months")
        .endOf("month")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastYear:
      endDate = moment()
        .subtract(1, "years")
        .endOf("year")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastMonthLastYear:
      endDate = moment()
        .subtract(13, "months")
        .endOf("month")
        .format("YYYY/MM/DD HH:mm:ss");
      break;
    case DateRanges.TwoMonths:
      endDate = moment()
        .subtract(2, "months")
        .endOf("month")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Last30Days:
      endDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Last60Days:
      endDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.Last90Days:
      endDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisFinancialYear:
      endDate = moment().endOf("year").format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisHMRCTaxYear:
      endDate = moment(`04/05/${moment().year()}`)
        .add(1, "years")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisVATYear:
      endDate = moment(`03/31/${moment().year()}`)
        .add(1, "years")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.ThisVATQuarter:
      if (
        moment().isSameOrAfter(vatLastQuarterEndDate) &&
        moment().isSameOrBefore(vatFirstQuarterEndDate)
      ) {
        endDate = vatFirstQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatFirstQuarterEndDate) &&
        moment().isSameOrBefore(vatSecondQuarterEndDate)
      ) {
        endDate = vatSecondQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatSecondQuarterEndDate) &&
        moment().isSameOrBefore(vatThirdQuarterEndDate)
      ) {
        endDate = vatThirdQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      }

      // If the date falls before the 31st of March or on or after 31st of December, we're in the final quarter of the year
      else if (
        moment().isSameOrAfter(vatThirdQuarterEndDate) ||
        moment().isSameOrBefore(moment(vatLastQuarterEndDate))
      ) {
        endDate = vatLastQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      }
      break;
    case DateRanges.LastVATQuarter:
      if (
        moment().isSameOrAfter(vatLastQuarterEndDate) &&
        moment().isSameOrBefore(vatFirstQuarterEndDate)
      ) {
        endDate = vatLastQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatFirstQuarterEndDate) &&
        moment().isSameOrBefore(vatSecondQuarterEndDate)
      ) {
        endDate = vatFirstQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatSecondQuarterEndDate) &&
        moment().isSameOrBefore(vatThirdQuarterEndDate)
      ) {
        endDate = vatSecondQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      } else if (
        moment().isSameOrAfter(vatThirdQuarterEndDate) ||
        moment().isSameOrBefore(moment(vatLastQuarterEndDate))
      ) {
        endDate = vatThirdQuarterEndDate.format("yyyy/MM/DD hh:mm:ss");
      }
      break;
    case DateRanges.LastFinancialYear:
      endDate = moment()
        .subtract(1, "years")
        .endOf("year")
        .format("yyyy/MM/DD hh:mm:ss");
      break;
    case DateRanges.LastHMRCTaxYear:
      endDate = moment(`04/05/${moment().year()}`).format(
        "yyyy/MM/DD hh:mm:ss",
      );
      break;
    case DateRanges.LastVATYear:
      endDate = moment(`03/31/${moment().year()}`).format(
        "yyyy/MM/DD hh:mm:ss",
      );
      break;
    case DateRanges.AllDates:
      endDate = moment().add(25, "years").format("yyyy/MM/DD hh:mm:ss");
      break;
    default:
      endDate = moment().format("yyyy/MM/DD hh:mm:ss");
      break;
  }

  return endDate;
};
